<template>
  <div>
    <ul class="card-list" v-if="list.length>0">
      <li v-for="item in list" :key="item.id" @click="handleSelect(item)">
        <!--banenr图-->
        <div class="banner-nrk">
          <template v-for="(img,index) in item.pic.split(',')" >
            <img v-lazy="ImgPreUrl+img"   class="banner" :key="index" v-if="index==0">
          </template>
        </div>
        <!--信息-->
        <div class="information">
          <h3 class="title">
            {{item.title}}
            <img v-lazy="'/images/zfxj/icon_'+item.state_star+'.png'" :key="item.state_star" height="16px" v-if="item.state_star>0"/>
            <img v-lazy="'/images/xj/icon_'+item.star+'.png'" :key="item.star" height="16px" v-else />
          </h3>
          <div class="star-info">
            <div class="star-text">{{item.star | formatVar('HotelStar')}}</div>
          </div>
          <!--双床房数量-->
          <div class="justify-content">
            <div class="one">
              <i class="iconfont icon-ruzhugongsi"></i>
              <span>总客房</span>
              <p>{{item.room_count}}</p>
              <p>间</p>
            </div>
            <div class="two" v-if="item.room_2_count>0">
              <i class="iconfont  icon-dachuang"></i>
              <span>双床房</span>
              <p>{{item.room_2_count}}</p>
              <p>间</p>
            </div>
          </div>
          <!--查看详情-->
          <div class="card-bottom">
            <div class="address">
              <div class="address-content">
                <i class="el-icon-location-information text-login mr-1"></i>
                <p>{{ parseAddress(item) }}</p>
              </div>
            </div>
            <div class="btn-group">
              <el-button type="primary" @click.stop="handleAddQuote(item)" :disabled="isIdExist(inquiryList,item.id,'id')" v-if="userInfo.type==2">加入询价</el-button>
              <el-button>查看详情</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!--骨架屏-->
    <ul  class="card-list skeleton" v-else>
      <li v-for="(item,index) in skeletonList" :key="index">
        <div class="banner-nrk">
          <p class="banner"></p>
        </div>
        <div class="information">
          <p class="star-info"></p>
          <h3 class="title"></h3>
          <div class="address"></div>
          <div class="bottom"></div>
        </div>
      </li>
    </ul>
  </div>
</template> 

<script>
import { mapState,mapGetters} from 'vuex'
import provinces from '@/assets/utils/provinces'             //省份信息
export default {
  name: 'ItemCard',
  components: {},
  props: {
    list:Array,
  },
  data() {
    return {
      //骨架屏
      skeletonList: [{},{},{},{}],
    };
  },
  computed: {
      ...mapGetters(['userInfo']),
      ...mapState(['inquiryList']),
  },
  watch: {},
  created() {},
  mounted() {
  },
  methods: {
    //获取本地地址信息
    parseAddress(res){
      let city = provinces.find(item => item.id == res.city);
      let district = provinces.find(item => item.id == res.district);
      return `${city.title}${district.title}${res.address}`;
    },
    //点击搜索框的建议项-跳转详情
    handleSelect(item) {
      this.$emit('viewDetails',item);
      // let changeRoute = this.$router.resolve('/index_hotel/hotel_detail/' + item.id);
      // window.open(changeRoute.href, '_blank');
      // this.searcValue={...this.searcValue,...item}
    },
    // 判断 id 是否存在
    isIdExist(arr, id, key) {
      return arr.some(item => item[key] === id)
    },
    //加入询价
    handleAddQuote(item){
      this.$emit('addQuote',item);
    },
  }
};
</script>

<style lang="scss" scoped>
  .card-list{
    width: 100%;
  }
  .card-list li{
    background-color: #fff;
    overflow: hidden;
    width: 100%;
    margin-bottom: 20px;
    display: flex;
    box-shadow: 0px 0px 7px #eee;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .card-list li .banner{
    width: 240px;
    text-align: left;
    height: 210px;
    transition: transform 0.25s ease;
  }
  .banner-nrk{
    width: 240px;
    height: 210px;
    overflow: hidden;
    margin-right: 20px;
  }
  .star-info{
    text-align: left;
    margin-top: 10px;
    display: flex ;
    margin-bottom: 10px;
    img{
      margin-top: 4px;
      margin-right: 8px;
    }
  }
  .star-text{
    // background-color: #eff6ff;
    // color: #12b2cb;
    border: 1px #eee solid;
    padding: 4px 10px;
    font-size: 12px;
    border-radius: 4px;
  }
  .title{
    text-align: left;
    margin: 8px 0;
    font-size: 18px;
    margin-top: 16px;
  }
  .address{
    color: #999;
    text-align: left;
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .address i{
    font-size: 14px;
  }
  .address-content{
    display: flex;
    align-items: center;
    p{
      overflow : hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;
    }
  }
  .justify-content{
    display: flex;
    margin-top: 16px;
    div{
      background-color: #f9fafb ;
      padding: 0 10px;
      display: flex;
      margin-right: 16px;
      border-radius: 6px;
      font-size: 12px;
      line-height: 34px;
      color: #4a5565;
      i{
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-right: 4px;
        color: #99a1af;
        font-size: 15px;
      }
    }
  }
  .information{
    width: 67%;
  }
  .justify-content .one p{  
    font-weight: bold;
    color: #333;
    margin-left: 4px;
  }

  .justify-content .two p{
    font-weight: bold;
    color: #333;
    margin-left: 4px;
    color: var(--smtc-color-primary); 
  }
  .card-list li:hover {
    box-shadow: 0px 0px 10px #ccc;
  }
  .card-list li:hover .banner{
    transform: scale(1.1);
  }
  .card-list li:hover .bottom .el-button{
    background-color: var(--smtc-color-primary);
    color: #fff;
  }
  .card-bottom{
    width: 100%;
    text-align: right;
    display: flex;
    justify-content:space-between;
    margin-top: 20px;
  }
  //------------------
  //骨架屏样式
  //------------------
  .skeleton .banner{
    position: relative;
    background-color: #f3f4f8;
  }
  .skeleton .banner::after,.skeleton .star-info::after,.skeleton .title::after,.skeleton .address::after,.skeleton .bottom::after{ 
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255 ), transparent);
    animation: skeleton-loading 1.5s infinite;
  }
  .skeleton .star-info{
    width: 100px;
    height: 20px;
    background-color: #f3f4f8;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
  .skeleton .title{
    width:300px;
    height: 40px;
    background-color: #f3f4f8;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
  .skeleton .address{
    width: 200px;
    height: 30px;
    background-color: #f3f4f8;
    border-radius: 4px;
    position: relative;
    overflow: hidden;
  }
  .skeleton .bottom{
    width: 140px;
    height: 40px;
    background-color: #f3f4f8;
    border-radius: 4px;
    float: right;
    margin-top: 30px;
    overflow: hidden;
    position: relative;
  }
  @keyframes skeleton-loading {
      0% { transform: translateX(-100%); }
      100% { transform: translateX(100%); }
  }
</style>
